var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDropdownBox24Line = function SvgIconDropdownBox24Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.45 4.9h-8.9C6.09 4.9 4.9 6.09 4.9 7.55v8.9c0 1.46 1.19 2.65 2.65 2.65h8.9c1.46 0 2.65-1.19 2.65-2.65v-8.9c0-1.46-1.19-2.65-2.65-2.65Zm.95 11.55a.95.95 0 0 1-.95.95h-8.9a.95.95 0 0 1-.95-.95v-8.9a.95.95 0 0 1 .95-.95h8.9a.95.95 0 0 1 .95.95v8.9Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.95 9.75h-3.9a1.152 1.152 0 0 0-.865 1.915l1.95 2.205c.22.245.53.385.86.385.33 0 .64-.14.86-.39l1.95-2.2c.3-.34.375-.825.185-1.235a1.16 1.16 0 0 0-1.05-.68h.01Z",
    fill: "current"
  })));
};
export default SvgIconDropdownBox24Line;